export enum MovementStatus {
    NoAction,
    Open,
    Closed,
}
